import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import Loader from 'components/Loader';
import useFields from 'components/Table/hooks/useFields';
import Pagination from 'components/Table/Pagination';
import ParserRestApi from 'helpers/ParserRestApi';

function Table(props) {
	const {t} = useTranslation();
	const [page, setPage] = useState(1);
	let {
		hook = () => {
			return {
				fetchAll: () => {
				}
			}
		},
		keyWatch = 'collection',
		columns = [],
		actions = [],
		title = '',
		limit = 2,
		componants = {}
	} = props;

	const {
		fields
	} = useFields();

	const data = hook();

	useEffect(() => {
		if (typeof data.launchMethod === 'function') {
			data.launchMethod('fetchAll', [page, limit]);
		}
	}, [page]);

	return (
		<section className="scroll-section Table">
			{title && (<h2 className="small-title">{title}</h2>)}
			{data[keyWatch].fetching && (
				<Loader />
			)}
			{data[keyWatch].error.status && (
				<>
					<div className="alert alert-danger" role="alert">
						{data[keyWatch].error.message}
					</div>
					{componants && componants.error && (
						<>{componants.error}</>
					)}
				</>
			)}
			{data[keyWatch].loaded && data[keyWatch].error.status === false && (
				<div className="card mb-5">
					<div className="card-body">
						<table className="table table-striped">
							<thead>
							<tr>
								{columns.map((column, indexColumn) => {
									return (
										<th scope="col" key={'columnth' + indexColumn}>{column.label}</th>
									);
								})}
								{actions.length > 0 && (
									<th scope="col">{t('Table.actions')}</th>
								)}
							</tr>
							</thead>
							<tbody>
							{data[keyWatch].items.map((item, indexItem) => {
								let trs = [];
								trs.push(
									<tr key={'line' + indexItem}>
										{columns.map((column, indexColumn) => {
											if (typeof item[column.key] === 'undefined') {
												return (null);
											}
											let type = 'text';
											if (typeof column.type !== 'undefined') {
												type = column.type;
											}

											return (
												<td key={'column' + indexColumn}>
													{typeof fields[type] === 'undefined' && item[column.key]}
													{typeof fields[type] !== 'undefined' && fields[type](item[column.key])}
												</td>
											);
										})}
										{actions.length > 0 && (
											<td className="actions">
												{
													item['@id'] &&
													data.delete &&
													data.delete.fetching &&
													data.delete.id &&
													data.delete.id === ParserRestApi.parseId(item['@id']) && (
														<Loader />
													)}
												{actions.map((action, indexAction) => {
													return (
														<div
															title={action.title ? action.title : ''}
															className="action"
															key={'action' + indexAction}
															onClick={() => {
																if (typeof action.onClick === 'function') {
																	action.onClick(item);
																}
															}}>
															{typeof action.getLabel === 'function' && (
																<>{action.getLabel(item)}</>
															)}
															{typeof action.getLabel !== 'function' && (
																<>{action.label}</>
															)}
														</div>
													);
												})}
											</td>
										)}
									</tr>
								);

								if (typeof componants.footerItem) {
									trs.push(componants.footerItem(item));
								}

								return trs;
							})}
							</tbody>
						</table>

						{data[keyWatch].loaded && (
							<Pagination
								total={data[keyWatch].total}
								limit={data[keyWatch].itemsPerPage}
								changePage={(page) => {
									setPage(page);
								}}
								currentPage={data[keyWatch].page}
							/>
						)}
					</div>
				</div>
			)}
		</section>
	);
}

export default Table;
